import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';

export default function InstallPrompt() {
  const { user, loading } = useAuth();
  const [show, setShow]         = useState(false);
  const [platform, setPlatform] = useState('android');
  const [installed, setInstalled] = useState(false);
  const [installing, setInstalling] = useState(false);
  const promptRef = useRef(null); // store prompt in ref, survives re-renders

  // ── Capture prompt as early as possible (before login) ──
  useEffect(() => {
    // Already installed?
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      setInstalled(true);
      return;
    }

   

    // Detect platform
    const ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua))  setPlatform('ios');
    else if (/android/.test(ua))       setPlatform('android');
    else                               setPlatform('desktop');

    // Use already-captured prompt from index.js
    if (window.__pwaInstallPrompt) {
      promptRef.current = window.__pwaInstallPrompt;
    }

    // Or capture it now
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      promptRef.current = e;
      window.__pwaInstallPrompt = e;
      console.log('[PWA] Install prompt captured');
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    const handleInstalled = () => {
      setInstalled(true);
      setShow(false);
    };
    window.addEventListener('appinstalled', handleInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  // ── Show popup after user logs in ──────────────────────
  useEffect(() => {
    if (loading || !user) return;
    if (installed) return;

    // Already dismissed permanently
    const dismissed = localStorage.getItem('zz_install_dismissed');
    if (dismissed) return;

    const ua = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua);

    if (isIOS) {
      // iOS — always show instructions (no prompt event on iOS)
      setTimeout(() => setShow(true), 2000);
    } else if (promptRef.current) {
      // Android/Desktop — prompt available
      setTimeout(() => setShow(true), 2000);
    } else {
      // Prompt not available yet — wait for it
      const waitForPrompt = () => {
        if (window.__pwaInstallPrompt) {
          promptRef.current = window.__pwaInstallPrompt;
          setTimeout(() => setShow(true), 1000);
        }
      };
      window.addEventListener('pwaInstallAvailable', waitForPrompt);
      return () => window.removeEventListener('pwaInstallAvailable', waitForPrompt);
    }
  }, [user, loading, installed]);

  // const handleInstall = async () => {
  //   const prompt = promptRef.current;
  //   if (!prompt) return;
  //   setInstalling(true);
  //   prompt.prompt();
  //   const { outcome } = await prompt.userChoice;
  //   if (outcome === 'accepted') {
  //     setShow(false);
  //     setInstalled(true);
  //     localStorage.setItem('zz_install_dismissed', 'installed');
  //   }
  //   setInstalling(false);
  //   promptRef.current = null;
  // };
const handleInstall = async () => {
  const prompt = promptRef.current || window.__pwaInstallPrompt;

  if (!prompt) {
    alert("Install is not available on this device/browser.");
    return;
  }

  setInstalling(true);

  prompt.prompt();

  const { outcome } = await prompt.userChoice;

  console.log("Install outcome:", outcome);

  if (outcome === "accepted") {
    setInstalled(true);
    setShow(false);
  }

  setInstalling(false);

  promptRef.current = null;
  window.__pwaInstallPrompt = null;
};

 
  const handleBeforeInstall = (e) => {
  e.preventDefault();
  promptRef.current = e;
  window.__pwaInstallPrompt = e;
  window.dispatchEvent(new Event('pwaInstallAvailable')); // ← add this line
  console.log('[PWA] Install prompt captured');
};

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem('zz_install_dismissed', 'dismissed');
  };

  if (loading || !user || !show || installed) return null;

  // ── iOS ─────────────────────────────────────────────────
  if (platform === 'ios') {
    return (
      <div style={{
        position:'fixed', bottom:84, left:12, right:12, zIndex:9999,
        background:'white', borderRadius:16, padding:'16px',
        boxShadow:'0 8px 32px rgba(0,0,0,.18)',
        border:'1.5px solid #1A6B3C20',
        animation:'slideUp .3s ease-out',
      }}>
        <style>{`@keyframes slideUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}`}</style>
        <button onClick={handleDismiss} style={{ position:'absolute', top:10, right:12, background:'none', border:'none', fontSize:20, color:'#9CA3AF', cursor:'pointer' }}>×</button>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12 }}>
          <img src="/logo192.png" alt="ZevaZeva" style={{ width:44, height:44, borderRadius:10 }} />
          <div>
            <div style={{ fontWeight:700, fontSize:14, color:'#1a2e05' }}>Install ZevaZeva</div>
            <div style={{ fontSize:12, color:'#6B7280' }}>Add to your home screen</div>
          </div>
        </div>
        <div style={{ fontSize:13, color:'#4B5563', lineHeight:1.8 }}>
          {[
            { n:'1', text:'Tap Share ⬆️ in Safari toolbar' },
            { n:'2', text:'Tap "Add to Home Screen"' },
            { n:'3', text:'Tap "Add" — done! 🎉' },
          ].map(s => (
            <div key={s.n} style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
              <span style={{ width:22, height:22, background:'#E8F5EE', borderRadius:6, display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, flexShrink:0, fontWeight:700, color:'#1A6B3C' }}>{s.n}</span>
              <span>{s.text}</span>
            </div>
          ))}
        </div>
        <button onClick={handleDismiss}
          style={{ width:'100%', marginTop:12, padding:'9px', background:'#F3F4F6', border:'none', borderRadius:10, fontSize:13, color:'#6B7280', cursor:'pointer' }}>
          Got it, maybe later
        </button>
      </div>
    );
  }

  // ── Android / Desktop ───────────────────────────────────
  return (
    <div style={{
      position:'fixed',
      bottom: platform==='desktop' ? 'auto' : 84,
      top:    platform==='desktop' ? 80 : 'auto',
      right:  platform==='desktop' ? 16 : 'auto',
      left:   platform==='desktop' ? 'auto' : 12,
      width:  platform==='desktop' ? 320 : 'calc(100% - 24px)',
      zIndex:9999,
      background:'white', borderRadius:16,
      boxShadow:'0 8px 32px rgba(0,0,0,.18)',
      border:'1.5px solid #1A6B3C30',
      overflow:'hidden',
      animation:'slideUp .3s ease-out',
    }}>
      <style>{`
        @keyframes slideUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        @keyframes spin{to{transform:rotate(360deg)}}
      `}</style>

      <div style={{ background:'linear-gradient(135deg,#1A6B3C,#2d8a55)', padding:'12px 14px', display:'flex', alignItems:'center', gap:10 }}>
        <img src="/logo192.png" alt="ZevaZeva" style={{ width:40, height:40, borderRadius:10, border:'2px solid rgba(255,255,255,.3)' }} />
        <div style={{ flex:1 }}>
          <div style={{ color:'white', fontWeight:700, fontSize:14 }}>Install ZevaZeva</div>
          <div style={{ color:'rgba(255,255,255,.8)', fontSize:11 }}>Fresh. Direct. Trusted.</div>
        </div>
        <button onClick={handleDismiss}
          style={{ background:'rgba(255,255,255,.2)', border:'none', borderRadius:'50%', width:28, height:28, color:'white', fontSize:16, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
          ×
        </button>
      </div>

      <div style={{ padding:'12px 14px' }}>
        {[
          { icon:'⚡', text:'Works offline — no internet needed' },
          { icon:'🔔', text:'Get notified about crop requests' },
          { icon:'📱', text:'App-like experience on your device' },
          { icon:'💾', text:'No Play Store needed — install directly' },
        ].map(b => (
          <div key={b.text} style={{ display:'flex', alignItems:'center', gap:8, marginBottom:7 }}>
            <span style={{ fontSize:16, width:24, textAlign:'center' }}>{b.icon}</span>
            <span style={{ fontSize:12, color:'#4B5563' }}>{b.text}</span>
          </div>
        ))}

        <div style={{ display:'flex', gap:8, marginTop:12 }}>
          <button onClick={handleDismiss}
            style={{ flex:1, padding:'10px', background:'#F3F4F6', border:'none', borderRadius:10, fontSize:13, color:'#6B7280', cursor:'pointer', fontWeight:500 }}>
            Not now
          </button>
          <button onClick={handleInstall} disabled={installing}
            style={{ flex:2, padding:'10px', background:'#1A6B3C', border:'none', borderRadius:10, fontSize:13, color:'white', cursor:'pointer', fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
            {installing
              ? <><span style={{ width:14, height:14, border:'2px solid rgba(255,255,255,.3)', borderTopColor:'white', borderRadius:'50%', animation:'spin .7s linear infinite', display:'inline-block' }} /> Installing...</>
              : '📲 Install App'
            }
          </button>
        </div>
      </div>
    </div>
  );
}